import { Breadcrumb, Col, Form, Input, Row, Select } from 'antd';
import React from 'react';
import CustomButton from 'base/ui/components/Button';
// icons
import * as Icon from 'base/ui/components/Icons';
import BoxContainer from 'base/ui/components/BoxContainer';
import { ProColumns, ProTable } from '@ant-design/pro-components';
import CustomSelect from 'base/ui/components/CustomSelect';
import { useTranslation } from 'react-i18next';
import { observer } from 'mobx-react';
import CustomInputString from 'base/ui/components/Input/customInputString';
import PageWrapper from 'pages/Components/PageWrapper';
import { SYSTEM_TITLE } from 'utils/constants';
import { ROUTES } from 'base/routes/routes';

interface DataType {
  key: string;
  stt?: number;
  zaloField: string;
  fieldName: string;
  mota: string;
}

const dataSource = [
  {
    key: '1',
    stt: 1,
    zaloField: 'Customer_Name',
    fieldName: '',
    mota: 'Tên liên hệ',
  },
  {
    key: '2',
    stt: 2,
    zaloField: 'Warranty_Date',
    fieldName: '',
    mota: 'Ngày bảo hành',
  },
  {
    key: '3',
    stt: 3,
    zaloField: 'Warranty_Code',
    fieldName: '',
    mota: 'Mã xử lý bảo hành',
  },
];

const createEditZNS = () => {
  return observer(() => {
    //=====================================CHUYỂN NGÔN NGỮ=====================================//
    const { t } = useTranslation();
    document.title = t('page-title.zalo-task') + ' - ' + SYSTEM_TITLE;
    const columns: ProColumns<DataType>[] = [
      {
        title: t('zalo-notification.zalo-field'),
        dataIndex: 'zaloField',
        key: 'zaloField',
        width: 250,
        // align: 'center',
      },
      {
        title: t('zalo-notification.field-name'),
        dataIndex: 'fieldName',
        key: 'fieldName',
        // align: 'center',
        render: () => {
          return <CustomSelect size="small" className="w-full" options={[{ value: 'value', label: 'label' }]} />;
        },
      },
      {
        title: t('zalo-notification.description'),
        dataIndex: 'mota',
        key: 'mota',
      },
    ];
    return (
      <PageWrapper
        breadcrumb={[
          {
            text: t('page-title.zalo-task'),
            to: ROUTES.ZALO_ZNS.ZALO_TASK_ZNS.LINK,
          },
          {
            text: t('page-title.edit'),
          },
        ]}
      >
        <BoxContainer>
          <Form wrapperCol={{ offset: 0, span: 24, lg: { offset: 2 } }} labelCol={{ span: 8 }}>
            <Row gutter={4}>
              <Col span={24} lg={{ span: 12 }}>
                <div className="flex flex-col gap-2">
                  <Form.Item label={t('search-form.major')} className="!m-0">
                    <CustomInputString value={'Bảo hành'} />
                  </Form.Item>
                  <Form.Item label={t('search-form.zns-code')} className="!m-0">
                    <CustomSelect />
                  </Form.Item>
                  <Form.Item label={t('zalo-notification.survey-name')} className="!m-0">
                    <CustomSelect />
                  </Form.Item>
                </div>
              </Col>
            </Row>
          </Form>
        </BoxContainer>
        {/* Form search */}
        <BoxContainer fullHeight>
          <ProTable<DataType>
            size="small"
            key={'stt'}
            className="border [&_.ant-pro-card_.ant-pro-card-body]:!p-0"
            options={false}
            scroll={{ x: 1000 }}
            dataSource={dataSource}
            columns={columns}
            pagination={false}
            dateFormatter="string"
            search={false}
          />
        </BoxContainer>
      </PageWrapper>
    );
  });
};

export default createEditZNS;
